import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { AuthService } from './auth.service';

export const defaultRedirectGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);
  const target = auth.hasPermission('SUPERVISION') ? '/pilotage' : '/accueil';
  return router.createUrlTree([target]);
};